import { ProductChangeOfAddressProcessStatus } from "@/api/constants/enums";
import { ShoppingCartConfigurationBundleDto } from "@/api/models/shoppingCart.model";
import { ProductChangeOfAddressService } from "@/api/services/productChangeOfAddressProcess.service";
import { PRODUCT_CHANGE_OF_ADDRESS_PROCESS_CLEAR_ACTION, PRODUCT_CHANGE_OF_ADDRESS_PROCESS_CLEAR_STATE } from "./constants";
import { VoipNumberPoolStoreMutations } from "../voipNumberPool";

const clear = ({ commit }: any) => {
	commit(PRODUCT_CHANGE_OF_ADDRESS_PROCESS_CLEAR_STATE);

	commit(VoipNumberPoolStoreMutations.CLEAR);
};

const createProductChangeOfAddressProcess = ({ commit }: any, payload: any) => {
	commit("activateOverlay", "overlay.savingCustomerChangeOfAddressProcess");
	return new Promise((resolve, reject) => {
		ProductChangeOfAddressService.create(payload)
			.then((response) => {
				if (response.data.id) commit("SET_PRODUCT_CHANGE_OF_ADDRESS_PROCESS_ID", response.data.id);

				commit("SET_PRODUCT_CHANGE_OF_ADDRESS_PROCESS_STATUS", ProductChangeOfAddressProcessStatus.FRESH);
				resolve(response);
			})
			.catch(reject)
			.finally(() =>
				setTimeout(() => {
					commit("desactivateOverlay");
				}, 1000)
			);
	});
};

const deleteProductChangeOfAddressProcess = ({ commit }: any, { id }: { id: number }) => {
	return new Promise((resolve, reject) => {
		return ProductChangeOfAddressService.delete(id)
			.then((response) => {
				resolve(response);
			})
			.catch(reject);
	});
};

const updateProductChangeOfAddressProcess = ({ commit }: any, payload: any) => {
	commit("activateOverlay", "overlay.savingCustomerChangeOfAddressProcess");
	return new Promise((resolve, reject) => {
		ProductChangeOfAddressService.update(payload.id, payload.data)
			.then((response) => {
				resolve(response.data);
			})
			.catch(reject);
	});
};

const getProductChangeOfAddressProcess = ({ commit }: any, id: number) => {
	return new Promise((resolve, reject) => {
		ProductChangeOfAddressService.get(id)
			.then((response) => {
				resolve(response.data);
			})
			.catch(reject);
	});
};

const saveProductChangeOfAddressProcess = ({ commit }: any, changeOfAddress: any) => {
	commit("SET_PRODUCT_CHANGE_OF_ADDRESS_PROCESS", changeOfAddress);
};

const saveProductChangeOfAddressProcessStatus = ({ commit }: any, status: string) => {
	commit("SET_PRODUCT_CHANGE_OF_ADDRESS_PROCESS_STATUS", status);
};

const saveProductChangeOfAddressProcessId = ({ commit }: any, id: string) => {
	commit("SET_PRODUCT_CHANGE_OF_ADDRESS_PROCESS_ID", id);
};

const getChangeOfAddressIntermediateSummary = ({ commit }: any, { shoppingCartId }: { shoppingCartId: string }) => {
	return new Promise((resolve, reject) => {
		ProductChangeOfAddressService.getChangeOfAddressIntermediateSummary({ shoppingCartId })
			.then((response) => {
				resolve(response.data);
			})
			.catch(reject);
	});
};

const getChangeOfAddressIntermediateConfiguration = ({ commit }: any, { shoppingCartId }: { shoppingCartId: string }) => {
	return new Promise((resolve, reject) => {
		ProductChangeOfAddressService.getChangeOfAddressIntermediateConfiguration({ shoppingCartId })
			.then((response) => {
				resolve(response.data);
			})
			.catch(reject);
	});
};

const saveProductChangeOfAddressShoppingCartId = ({ commit }: any, shoppingCartId: string) => {
	commit("SET_PRODUCT_CHANGE_OF_ADDRESS_SHOPPING_CART_ID", shoppingCartId);
};

const updateProductChangeOfAddressIntermediateConfiguration = (
	{ commit }: any,
	{ shoppingCartId: id, bundles }: { shoppingCartId: string; bundles: ShoppingCartConfigurationBundleDto[] }
) => {
	return new Promise((resolve, reject) => {
		ProductChangeOfAddressService.putChangeOfAddressIntermediateConfiguration({ id, bundles })
			.then((response) => {
				resolve(response.data);
			})
			.catch(reject);
	});
};

const sendChangeOfAddress = ({ commit }: any, id: string) => {
	return new Promise((resolve, reject) => {
		ProductChangeOfAddressService.send(id)
			.then((response) => {
				resolve(response.data);
			})
			.catch(reject);
	});
};

const saveOrderChangeOfAddress = ({ commit }: any, payload: string) => {
	commit("SET_ORDER_CHANGE_OF_ADDRESS", payload);
};

export default {
	[PRODUCT_CHANGE_OF_ADDRESS_PROCESS_CLEAR_ACTION]: clear,
	createProductChangeOfAddressProcess,
	deleteProductChangeOfAddressProcess,
	updateProductChangeOfAddressProcess,
	getProductChangeOfAddressProcess,
	saveProductChangeOfAddressProcess,
	saveProductChangeOfAddressProcessStatus,
	saveProductChangeOfAddressProcessId,
	getChangeOfAddressIntermediateSummary,
	getChangeOfAddressIntermediateConfiguration,
	saveProductChangeOfAddressShoppingCartId,
	updateProductChangeOfAddressIntermediateConfiguration,
	sendChangeOfAddress,
	saveOrderChangeOfAddress
};
